import { AdminPrivateLayout, AdminPublicLayout } from "layouts";
import publicRoutes from "./public.route";
import privateRoutes from "./private.route";

/**
 * Generates the route configuration for the admin section of the application.
 * @param {Function} t - Translation function used for localization.
 * @returns {Array} An array with two route objects.
 * @function adminRoutes
 */
export const adminRoutes = (t) => {
  return [
    {
      element: <AdminPublicLayout />,
      children: [...publicRoutes(t)],
    },
    {
      element: <AdminPrivateLayout />,
      children: [...privateRoutes(t)],
    },
  ];
};
